import { EDITOR_MODE } from "@pathwright/blocks-engine"
import { ImageEdit } from "@pathwright/blocks/src/shared"
import Pathicon from "@pathwright/ux/src/components/pathicon/Pathicon"
import { removeHTML } from "../../utils"
import { FlashcardImagePicker, FlashcardImageWrapper } from "./ui"
import { getStaticSampleImage, hasLegacyImage } from "./utils"

const FlashcardImage = (props) => {
  const { sideName, side, updateContent, mode } = props

  const applyImage = async () => {
    if (mode === EDITOR_MODE.VIEW) return

    // Ask for an unsplash sample image,
    // then update the flashcard image with the static url
    if (side.image === "") {
      const image = await getStaticSampleImage()
      if (image) {
        updateContent(sideName, "image", image)
      }
    }
  }

  const handleClickImagePicker =
    ({ onClick }) =>
    (event) => {
      if (!!side.image) {
        updateContent(sideName, "image", "")
      } else {
        onClick()
      }
    }

  return (
    <FlashcardImageWrapper>
      <ImageEdit
        image={side.image && !hasLegacyImage(side) ? side.image : ""}
        altText={
          side.altText ||
          (side.html ? `Image for ${removeHTML(side.html)}` : "")
        }
        onChangeImage={(image, altText) => {
          updateContent(sideName, ["image", "altText"], [image, altText])
        }}
        backgroundMode={true}
        readOnly={mode === EDITOR_MODE.VIEW}
        imagePickerOptions={{
          transformations: {
            crop: { aspectRatio: 1, force: true }
          }
        }}
        renderButton={({ onClick }) => (
          <FlashcardImagePicker
            onClick={handleClickImagePicker({ onClick })}
            onImage={!!side.image}
            icon={
              <Pathicon
                icon="file-image"
                size="1em"
                fill={!!side.image ? "rgb(13, 113, 251)" : ""}
              />
            }
          />
        )}
      />
    </FlashcardImageWrapper>
  )
}

export default FlashcardImage
